<template>
  <transition
    name="el-message-fade"
    @after-leave="handleAfterLeave"
  >
    <div
      v-show="visible"
      :class="[
        'el-message',
        'rt-message',
        type && !iconClass ? `rt-message--${type}` : '',
        center ? 'is-center' : '',
        showClose ? 'is-closable' : '',
        customClass
      ]"
      :style="positionStyle"
      role="alert"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <icon
        :name="type==='info'||type==='success'?'rt-base-circle-check-filled':'rt-base-circle-warning-filled'"
        class="rt-message-prefix-icon"
        :class="`rt-message-${type}`"
        size="16"
      />
      <slot>
        <p
          v-if="!dangerouslyUseHTMLString"
          class="el-message__content"
        >
          {{ message }}
        </p>
        <div
          v-else-if="wrapMessage"
          class="el-message__content"
        >
          <div
            v-for="(item,index) in wrapMessage"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <p
          v-else
          class="el-message__content"
          v-html="message"
        ></p>
      </slot>
      <rt-button
        v-if="showClose"
        class="rt-message-close"
        icon-name="rt-base-close-x"
        text
        icon-size="16"
        @click="close"
      />
    </div>
  </transition>
</template>

<script type="text/babel">
import RtButton from '../../button/rtButton';
import Icon from '../../icon/rtIcon';
const typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

export default {
  components: {
    RtButton,
    Icon
  },
  data () {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      onClose: null,
      showClose: false,
      closed: false,
      verticalOffset: 20,
      dangerouslyUseHTMLString: false,
      center: false,
      contentSelector: '.app-content',
      wrapMessage: null
    };
  },

  computed: {
    typeClass () {
      return this.type && !this.iconClass ? `el-message__icon el-icon-${typeMap[this.type]}` : '';
    },
    positionStyle () {
      return {
        top: `${this.verticalOffset}px`
      };
    }
  },

  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false;
      }
    }
  },
  mounted () {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
    if (this.message && this.message.includes('\n')) {
      this.dangerouslyUseHTMLString = true
      this.wrapMessage = this.message.split('\n')
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.keydown);
  },

  methods: {
    handleAfterLeave () {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },

    close () {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },

    clearTimer () {
      clearTimeout(this._timer);
    },

    startTimer () {
      clearTimeout(this._timer);
      if (this.duration > 0) {
        this._timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    keydown (e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?24668dec